module.exports = __webpack_public_path__ + "media/images/checkmark-6440a1bd.svg";